import { createRoutine } from 'redux-saga-routines';

export const addNodeConfigurations = createRoutine('ADD_NODE_CONFIGURATIONS');
export const removeNodeConfiguration = createRoutine(
  'REMOVE_NODE_CONFIGURATION'
);
export const removeNodeConfigurations = createRoutine(
  'REMOVE_ALL_NODE_CONFIGURATIONS'
);
export const setScenarioMetaData = createRoutine('SET_SCENARIO_META_DATA');
export const loadNodeConfigurations = createRoutine('LOAD_NODE_CONFIGURATIONS');
export const resetCanvas = createRoutine('RESET_TO_CANVAS_INITIAL_STATE');
